import { cx } from "./ui";

/**
 * The Galeway "G" mark (source artwork in assets/brand/, built by
 * scripts/build-brand-assets.py).
 *  - "auto":  blue on light surfaces, white in dark mode
 *  - "white": always white (navy sidebar, login hero)
 *  - "color": always blue
 */
export function GalewayMark({ className, tone = "auto" }: { className?: string; tone?: "auto" | "white" | "color" }) {
  const img = (src: string, extra?: string) => (
    <img src={src} alt="" width={32} height={32} draggable={false} className={cx("shrink-0 select-none object-contain", className, extra)} />
  );
  if (tone === "white") return img("/brand/galeway-mark-white-128.png");
  if (tone === "color") return img("/brand/galeway-mark-128.png");
  return (
    <>
      {img("/brand/galeway-mark-128.png", "dark:hidden")}
      {img("/brand/galeway-mark-white-128.png", "hidden dark:block")}
    </>
  );
}

export function GalewayLogo({ className, inverted }: { className?: string; inverted?: boolean }) {
  return (
    <span className={cx("inline-flex items-center gap-2.5", className)}>
      <GalewayMark className="size-8" tone={inverted ? "white" : "auto"} />
      <span className={cx("text-[17px] font-semibold tracking-tight", inverted ? "text-white" : "text-fg")}>Galeway</span>
    </span>
  );
}
